import { Helmet } from 'react-helmet-async';
import React from 'react';
import NotificationContainer from '../../../containers/notification/NotificationsContainer.jsx';
import UserContainer from '../../../containers/organizations/UserContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const ShowUser = ({ userId }) => (
  <>
    <Helmet>
      <title>Profile | ChangeSync</title>
    </Helmet>

    <UserContainer userId={userId} />
    <NotificationContainer />
  </>
);

ShowUser.getInitialProps = ({ query }) => ({
  userId: Number(query.userId),
});

export default requireAuth(withRouterParams(ShowUser));
